import React, { useState, useEffect } from 'react';
import { Row, Col, Input, Select, Divider, Table } from 'antd';
import { sendData } from '../../httpRequests';
import { useNavigate } from 'react-router-dom';
import { getPharmacyId } from '../../components/Shared';
import CreateOrders from './CreateOrders';


const { Search } = Input;
const { Option } = Select;

export default function Orders() {
	const navigate = useNavigate();
	const [filteredOrders, setFilteredOrders] = useState([]);
	const [orders, setOrders] = useState([]);

	useEffect(() => {
		const pharmacyId = getPharmacyId();
		if (!pharmacyId) {
			navigate('/login');
			return false;
		}

		const url = '/orders/getAllOrdersByPharmacy';
		const data = {
			pharmacy_id: pharmacyId
		};
		sendData(url, data).then((response) => {
			if (Object.keys(response).length > 0) {
				const orders = response['order'];
				setOrders(orders);
				setFilteredOrders(orders);
			}
		});
	}, []);

	const onSearch = ({target}) => {

		const text = target.value;
		console.log(target.value)
		setTimeout(() => {
			if (text) {
				const filteredOrders2 = filteredOrders.filter((order) => order.code.includes(text));
				setFilteredOrders(filteredOrders2);
			} else {
				setFilteredOrders(orders);
			}
		}, 1000);
	};

	const handleChange = (value) => {
		setFilteredOrders(orders)
		if (value) {
			const filteredOrders2 = orders.filter((order) => order.order_state_id == value);
			setFilteredOrders(filteredOrders2);
		} else {
			setFilteredOrders(orders);
		}
	};

	const cropDate = (dateStr) => {
		const date = new Date(dateStr);
		return <span>{date.toDateString()}</span>;
	};

	const columns = [
		{ title: 'Order #', dataIndex: 'code', key: 'code' },
		{
			title: 'Status',
			render: ({ order_state_id }) => (
				<span>
					{(order_state_id == 1 && 'Pending') ||
						(order_state_id == 2 && 'Processing') ||
						(order_state_id == 3 && 'Ready for pick up by delivery') ||
						(order_state_id == 4 && 'On the way') ||
						(order_state_id == 5 && 'Delivered') ||
						(order_state_id == 6 && 'Rejected') ||
						(order_state_id == 7 && 'Ready to be picked up by client')}
				</span>
			),
			key: 'order_state_id'
		},
		{
			title: 'For Pickup',
			render: ({ pick_up_status }) => <span>{(pick_up_status == 1 && 'Yes') || 'No'}</span>
		},
		{
			title: 'Date',
			render: ({ created_at }) => cropDate(created_at),
			key: 'created_at',
			defaultSortOrder: 'descend',
            sorter: {
            	compare: (a, b) => new Date(a.created_at) - new Date(b.created_at),
            	multiple: 1
            },
		},
		{ title: 'Total $', dataIndex: 'total_order', key: 'total_order' }
	];

	return (
		<div>
			<Row gutter={24}>
				<Col span={10}>
					<Search size='large' placeholder='Search order by order number' onChange={onSearch} />
				</Col>
				<Col span={10}>
					<Select
						placeholder='Select status'
						defaultValue={''}
						size='large'
						onChange={handleChange}
						style={{ width: '100%' }}
					>
						<Option value=''>All</Option>
						<Option value='1'>Pending</Option>
						<Option value='2'>Proccesing</Option>
						<Option value='3'>Ready for pick up by delivery</Option>
						<Option value='4'>On the way</Option>
						<Option value='5'>Delivered</Option>
						<Option value='6'>Rejected</Option>
						<Option value='7'>Ready to be picked up by client</Option>
						{/* <Option value='8'>Received by the client</Option> */}
					</Select>
				</Col>
				<Col span={4}>
					<CreateOrders />
				</Col>
			</Row>
			<Divider />
			<Row gutter={24}>
				<Col span={24}>
					<Table
						columns={columns}
						dataSource={filteredOrders}
						rowKey={(item) => item.id}
						onRow={(record) => {
							return {
								onClick: () => navigate('/orderDetails/' + record.id)
							};
						}}
					/>
				</Col>
			</Row>
		</div>
	);
}
